import { useEffect, useRef } from 'react';

export default function PhilosophyAccess() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .scale-in').forEach((el) => {
              el.classList.add('visible');
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-3xl md:text-4xl font-normal text-center text-gray-900 mb-4 fade-up"
          style={{ fontFamily: 'Noto Serif JP, serif' }}
        >
          アクセス
        </h2>
        <p className="text-center text-lg text-gray-700 mb-12 fade-up">
          場所:大通駅直結 moyukSAPPORO2F
        </p>

        <div className="bg-white rounded-2xl overflow-hidden scale-in">
          <div className="grid md:grid-cols-2 min-h-[420px]">
            {/* テキストエリア */}
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <h3
                className="text-xl md:text-2xl font-bold text-gray-900 mb-4"
                style={{ fontFamily: 'Noto Serif JP, serif' }}
              >
                さいわいデンタルクリニック<br />moyuk SAPPORO
              </h3>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                札幌市営地下鉄 大通駅直結<br />
                お買い物やお仕事帰りに、立ち寄りやすい場所です。
              </p>
              <div className="space-y-1 text-sm text-gray-700 mb-6">
                <p>〒060-0062</p>
                <p>北海道札幌市中央区南2条西3丁目20番地</p>
                <p>moyuk SAPPORO 2F</p>
                <a
                  href="tel:0118027996"
                  className="text-lg font-bold mt-3 inline-block hover:underline cursor-pointer text-gray-900"
                >
                  011-802-7996
                </a>
              </div>
              <a
                href="https://saiwaidental.jp/moyuk/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-1 font-medium text-sm whitespace-nowrap"
                style={{ color: '#3E5F8F' }}
              >
                診療時間・院内写真は医院HPで確認できます
                <i className="ri-arrow-right-line text-xs" />
              </a>
            </div>
            {/* 画像エリア */}
            <div className="md:h-auto">
              <img
                alt="クリニック外観"
                className="w-full h-auto md:h-full object-cover object-top"
                src="https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-1024x1536_v-fms_webp_996baba1-e344-482e-bb22-6b7533c2dcd6_small.webp"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
